module.exports = __webpack_public_path__ + "aea7b705197aefbc2f53f9fccde09a9a.MP3";